/* globals I18n */
import React from "react";

import BadgeThirtySix from "AssetImages/shields/shield_3636_en.png";
import BadgeThirtySixEnCa from "AssetImages/shields/shield_3660_can_en.png";
import BadgeThirtySixFrCa from "AssetImages/shields/shield_3660_can_fr-CA.png";

import BadgeTwentyFour from "AssetImages/shields/shield_2424_en.png";
import BadgeTwentyFourEnCa from "AssetImages/shields/shield_2440_can_en.png";
import BadgeTwentyFourFrCa from "AssetImages/shields/shield_2440_can_fr-CA.png";

import BadgeRoadHazard from "AssetImages/shields/shield_road_hazard_en.png";
import BadgeRoadHazardFrCa from "AssetImages/shields/shield_road_hazard_can_fr-CA.png";

import BadgeRoadAssistance from "AssetImages/shields/shield_roadside_assistance_en.png";
import BadgeRoadAssistanceFrCa from "AssetImages/shields/shield_roadside_assistance_can_fr-CA.png";

const Badge = ({ x36_36, road_hazard, country }) => {
  let badge36 = BadgeThirtySix;
  let badge24 = BadgeTwentyFour;
  let badgeHazard = BadgeRoadHazard;
  let badgeAssistance = BadgeRoadAssistance;

  if (country === "CA") {
    badge36 = BadgeThirtySixEnCa;
    badge24 = BadgeTwentyFourEnCa;
  }

  if (country === "CA" && I18n.locale === "fr-CA") {
    badge36 = BadgeThirtySixFrCa;
    badge24 = BadgeTwentyFourFrCa;
    badgeHazard = BadgeRoadHazardFrCa;
    badgeAssistance = BadgeRoadAssistanceFrCa;
  }

  return (
    <div className="flex gap-2">
      {x36_36 ? (
        <img className="w-8 mt-4" src={badge36} alt="36 36 badge" />
      ) : (
        <img className="w-8 mt-4" src={badge24} alt="24 24 badge" />
      )}
      {(
        <img className="w-8 mt-4" src={badgeAssistance} alt="road assistance badge" />
      )}
      {road_hazard && (
        <img className="w-8 mt-4" src={badgeHazard} alt="road hazard badge" />
      )}
    </div>
  );
};

export default Badge;
